export enum TipoProcessoExportacaoSimplesEnum {

  SolicitacaoExclusao = "Solicitação de Exclusão"
}
